import React, { createContext, useContext, useState } from 'react';

const T = {
  EN: {
    freeChat: 'Free Chat',
    introductions: 'Introductions',
    likesDislikes: 'Likes & Dislikes',
    hobbies: 'Hobbies',
    conversationPractice: 'Conversation Practice',
    grade5: 'Grade 5',
    grade6: 'Grade 6',
    gradeUnitSelection: (n) => `Grade ${n} - Unit Selection`,
    unit: (n) => `Unit ${n}`,
    chooseYourTeacher: 'Choose Your Teacher',
    conversationComplete: 'Conversation Complete!',
    backToMenu: 'Back to Menu',
    hint: 'Hint',
    tapToSpeak: '🎙️ Tap to Speak',
    done: '✅ Done',
    skip: 'Skip',
    listening: 'Listening…',
    settings: 'Settings',
    subtitles: 'Subtitles',
    speechNotSupported: 'Speech Recognition not supported. Please use Chrome or Safari.',
    langToggle: 'JP',
  },
  JP: {
    freeChat: 'フリーチャット',
    introductions: '自己紹介',
    likesDislikes: '好き・きらい',
    hobbies: '趣味',
    conversationPractice: '会話練習',
    grade5: '5年生',
    grade6: '6年生',
    gradeUnitSelection: (n) => `${n}年生 ー ユニット選択`,
    unit: (n) => `ユニット ${n}`,
    chooseYourTeacher: '先生を選んでね',
    conversationComplete: '会話完了！',
    backToMenu: 'メニューに戻る',
    hint: 'ヒント',
    tapToSpeak: '🎙️ タップして話す',
    done: '✅ 完了',
    skip: 'スキップ',
    listening: '聞いています…',
    settings: '設定',
    subtitles: '字幕',
    speechNotSupported: '音声認識は使えません。ChromeかSafariをお使いください。',
    langToggle: 'EN',
  },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState('EN');
  const toggleLang = () => setLang(l => (l === 'EN' ? 'JP' : 'EN'));
  return (
    <LangContext.Provider value={{ lang, t: T[lang], toggleLang }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
